import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n";
import { LOGO_NAVBAR, BRAND_NAME } from "../../constants";

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-[#030810] border-t border-white/10 py-12" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src={LOGO_NAVBAR} alt={BRAND_NAME} className="h-12 w-auto" />
            <span className="text-gray-400 text-sm">
              © {new Date().getFullYear()} {BRAND_NAME}. {t('footer.rights')}
            </span>
          </div>
          <div className="flex items-center gap-6">
            <Link 
              to="/admin" 
              className="text-gray-500 hover:text-gray-300 text-xs transition-colors"
            >
              Admin
            </Link>
            <p className="text-gray-500 text-xs max-w-md">
              <span className="text-cyan-400 font-medium">{t('footer.legalNotice')}</span> {t('footer.legalText')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
